import React, { useEffect, useRef, useState } from 'react';
import {
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Bar,
    BarChart,
} from 'recharts';
import './charD3.scss'
import { useTranslation } from 'react-i18next';
import { Spinner } from "react-bootstrap";
import { toPng } from 'html-to-image';

export interface charData {
    date: string
    numItems: number,
}

const CustomTooltip: React.FC<{
    active?: boolean;
    payload?: any[];
    label?: string;
}> = ({ active, payload }) => {
    const { t } = useTranslation();

    if (active && payload && payload.length) {
        return (
            <div className="customTooltip ps-2 pe-2" >
                <p><strong>{t('Date')}</strong> {payload[0].payload.date}</p>
                <p><strong>{t('NumOperations')}</strong> {payload[0].payload.numItems}</p>
            </div>
        );
    }

    return null;
};


const CharD3 = (props: { dataChar: charData[], loading: boolean, capture: boolean, title: string, setPNGChar: (s: string) => void }) => {

    const [maxYaxis, setMaxYaxis] = useState(0)
    const { t } = useTranslation();
    const charRef = useRef(null)
    const [capture, setCapture] = useState(props.capture)

    useEffect(() => {

        const valMax = props.dataChar.reduce((max, data) => {
            return Math.max(max, data.numItems);
        }, -Infinity);

        setMaxYaxis(parseInt((valMax + 2).toFixed(0)))

    }, [props.dataChar])

    useEffect(() => {
        if (charRef.current && props.dataChar.length > 0 && capture) {
            setTimeout(() => {
                if (charRef.current && props.dataChar.length > 0) {
                    toPng(charRef.current)
                        .then((dataUrl) => {
                            setCapture(false)
                            props.setPNGChar(dataUrl);
                        })
                        .catch((error) => {
                            console.error('Error al capturar la imagen:', error);
                        })
                }
            }, 500)
        }
    }, [props.dataChar, props.setPNGChar, charRef.current]);


    return (
        <div className='text-center rounded-1' id='containerCharD3Style'>
            <div className='row titleRowD3'>
                <span>{props.title}</span>
            </div>
            {props.loading ? <div className="text-center pt-5"><Spinner animation="border" variant="success" style={{ color: 'var(--accent-color)' }}/></div> : props.dataChar.length > 0 ? <div className='row charD3Row'>
                <div className='col me-1 mt-4' ref={charRef}>
                    <ResponsiveContainer width="100%" height="90%">
                        <BarChart
                            data={props.dataChar}
                            margin={{
                                top: 10,
                                right: 5,
                                left: 0,
                                bottom: 0,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3"/>
                            <XAxis dataKey="date" tick={{ fill: 'var(--text-primary)' }} />
                            <YAxis domain={[0, maxYaxis]} tick={{ fill: 'var(--text-primary)' }} />
                            <Tooltip content={<CustomTooltip />} />
                            <Bar dataKey="numItems" fill='var(--accent-color)' barSize={20} radius={[5, 5, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div> : <p>{t('NoData')}</p>}
        </div>
    )
}
export default CharD3